<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      :class="{'w100': !label}"
      v-model="valueBackup"
      :placeholder="placeholder"
      :multiple="multiple"
      :clearable="clearable"
      :size="size"
      :disabled="disabled"
      :style="width ? `width: ${width}` : ''"
    >
      <el-option
        v-for="item in paymentModes"
        :key="item.value"
        :label="item.name"
        :value="item.value"
        :disabled="disabledIds.includes(item.value)"
      />
    </el-select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import { index } from '@/api/card-payment-mode';
import { paymentModes } from '@/enums/paymentModes';

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Array],
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择收款方式',
    },
    multiple: Boolean,
    clearable: Boolean,
    size: {
      type: String,
      default: 'medium',
    },
    disabled: Boolean,
    disabledIds: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    valueBackup: '',
    paymentModes,
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {

  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }
  },
};
</script>
